import React, { useRef, useState } from 'react';
import { classNames } from 'primereact/utils';
import { useHistory } from "react-router-dom";
import { Button } from 'primereact/button';
import { Toast } from 'primereact/toast';
import { Skeleton } from 'primereact/skeleton';

import { useFormik } from 'formik';
import { ErrorValidationMessage } from './ErrorValidationMessage';
import { BrCalendar } from './BrCalendar';
import '../layout/sass/_form.scss';
import api from '../api/api';
import { TabelaDashboard } from './TabelaDashboard';

export const FormDashboard = ({ isEditing, isLoading }) => {
    const history = useHistory();
    const toast = useRef(null);
    const [isSubmiting, setIsSubmiting] = useState(false);
    const [buscaDatas, setBuscaDatas] = useState('');
    const [dt, setDt] = useState(null);
    const [dateSearchEmissao, setDateSearchEmissao] = useState('');
    const [isTabelaVisible, setIsTabelaVisible] = useState(true); // Novo estado para controlar a visibilidade da TabelaDashboard
    const dateFilterEmissao = renderDateFilterEmissao();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setBuscaDatas((values) => ({
            ...values,
            [name]: value,
        }));
    };

    const formik = useFormik({
        initialValues: {
            "dataEmissao": "",
            "numeroPedras": "",
            "idPedras": 0
        },
        enableReinitialize: true,
        onSubmit: async (data) => {
            setIsSubmiting(true);

            try {
                if (!isEditing) {
                    const response = await api.post("/pedras/ocupadas", buscaDatas.dataEmissao);
                    formik.setValues(response.data);
                    formik.setFieldValue("dataEmissao", buscaDatas.dataEmissao);
                    setBuscaDatas(response.data);

                    response.data === '' ?
                        toast.current.show({ life: 2000, severity: 'error', summary: 'Nenhuma Pedras encontrada' }) :
                        toast.current.show({ life: 2000, severity: 'success', summary: 'Pesquisa concluída!' });

                    setTimeout(() => {
                        history.push('/admin');
                    }, 2000);

                    // Mudar o estado da tabela para visível após uma nova pesquisa
                    setIsTabelaVisible(true);
                }
            } catch (error) {
                if (!isEditing) {
                    toast.current.show({ life: 2000, severity: 'error', summary: 'Erro ao pesquisar!', detail: error.toString() });
                }
            }

            setIsSubmiting(false);
        }
    });

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);

    function renderDateFilterEmissao() {
        return (
            <BrCalendar
                value={dateSearchEmissao}
                onChange={(e) => onDateSearchChangeEmissao(e)}
                placeholder="Data Inicial"
                yearRange={`2000:${new Date().getFullYear()}`}
            />
        );
    }

    const onDateSearchChangeEmissao = (event) => {
        if (event.value !== null) {
            dt.filter(event.value, 'dataEmissao', 'custom');
        } else {
            dt.filter(null, 'dataEmissao', 'equals');
        }

        setDateSearchEmissao(event.value);
    };

    function formatDatex(date) {
        var month = date.split("/")[1],
            day = date.split("/")[0],
            year = date.split("/")[2];
        if (month < 10)
            month = '0' + month;
        if (day < 10)
            day = '0' + day;

        return [year, month, day].join('-');
    }

    const filterDateEmissao = (value, filter) => {
        if (filter === undefined || filter === null || (typeof filter === 'string' && filter.trim() === '')) {
            return true;
        }

        if (value === undefined || value === null) {
            return false;
        }

        return new Date(formatDatex(value)) >= new Date(formatDatex(formatDate(filter)));
    };

    const formatDate = (date) => {
        let month = date.getMonth() + 1;
        let day = date.getDate();

        if (month < 10) {
            month = '0' + month;
        }

        if (day < 10) {
            day = '0' + day;
        }

        return day + '/' + month + '/' + date.getFullYear();
    };

    return (
        <div className="card p-grid p-col-12 p-mx-0 p-mt-0">
            <Toast ref={toast} position="bottom-right" />
            <div className="p-col-12">
                <form onSubmit={formik.handleSubmit}>
                    <div className="p-formgrid p-grid p-fluid p-mx-0">
                        <div className="p-field p-col-12 p-sm-4 p-md-4"></div>

                        <div className="p-field p-col-12 p-sm-3 p-md-3">
                            <label
                                htmlFor="dataEmissao"
                                className={classNames({ 'p-error': isFormFieldValid('dataEmissao') })}
                            >
                                Data da pesquisa
                            </label>
                            {
                                !isLoading ?
                                    <BrCalendar
                                        id="dataEmissao"
                                        name="dataEmissao"
                                        value={buscaDatas.dataEmissao}
                                        onChange={handleChange}
                                        readonly={true}
                                        className={classNames({ 'p-invalid': isFormFieldValid('dataEmissao') })}
                                        yearRange={`1900:${new Date().getFullYear() + 1}`}
                                        filter
                                        filterMatchMode="custom"
                                        filterFunction={filterDateEmissao}
                                        filterElement={dateFilterEmissao}
                                    />
                                    :
                                    <Skeleton height="35px" />
                            }
                            {formik.errors.dataEmissao && formik.touched.dataEmissao &&
                                <ErrorValidationMessage message={formik.errors.dataEmissao} />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-1 p-md-1">
                            {
                                !isLoading ?
                                    <Button
                                        label={'Pesquisar'}
                                        type="submit"
                                        iconPos="right"
                                        loading={isSubmiting}
                                        style={{ 'marginTop': '22px' }}
                                        onClick={() => history.push('/admin')}
                                    />
                                    :
                                    <Skeleton width="82.16px" height="35px" />
                            }
                        </div>

                        <div className="p-field p-col-12 p-sm-4 p-md-4"></div>
                    </div>
                </form>
            </div>

            {/* Botão para ocultar/mostrar a TabelaDashboard */}
            <div className="p-field p-col-12 p-sm-4 p-md-4">
                <Button
                    label={isTabelaVisible ? 'Ocultar Pedras' : 'Mostrar Pedras'}
                    onClick={() => setIsTabelaVisible(!isTabelaVisible)}
                />
            </div>

            {isTabelaVisible && <TabelaDashboard data={formik.values} buscaDatas={buscaDatas} />}
        </div>
    );
};